import React from 'react';
import {
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  MenuPopover,
  MenuTrigger,
  makeStyles,
  tokens,
} from '@fluentui/react-components';
import {
  WeatherSunny20Regular,
  WeatherMoon20Regular,
  ChevronDown20Regular,
} from '@fluentui/react-icons';
import { useTheme } from '../utils/theme';

const useStyles = makeStyles({
  menuButton: {
    minWidth: '120px',
  },
  menuItem: {
    display: 'flex',
    alignItems: 'center',
    gap: tokens.spacingHorizontalS,
  },
});

export const ThemeSelector: React.FC = () => {
  const classes = useStyles();
  const { currentTheme, themes, setTheme } = useTheme();

  const getThemeIcon = (isDark: boolean) => {
    return isDark ? <WeatherMoon20Regular /> : <WeatherSunny20Regular />;
  };

  return (
    <Menu>
      <MenuTrigger disableButtonEnhancement>
        <MenuButton
          appearance="subtle"
          icon={getThemeIcon(currentTheme.isDark)}
          menuIcon={<ChevronDown20Regular />}
          className={classes.menuButton}
        >
          {currentTheme.name}
        </MenuButton>
      </MenuTrigger>

      <MenuPopover>
        <MenuList>
          {themes.map((theme) => (
            <MenuItem
              key={theme.name}
              onClick={() => setTheme(theme)}
              className={classes.menuItem}
            >
              {getThemeIcon(theme.isDark)}
              {theme.name}
            </MenuItem>
          ))}
        </MenuList>
      </MenuPopover>
    </Menu>
  );
};

export default ThemeSelector;
